export default __webpack_public_path__ + "static/media/chart.a84f440e.svg";